const menuConfig = [
    {
      title: 'About Us',
      path: 'aboutSection'
    },
    {
      title: 'Sign Up',
      path: 'https://app.starjobs.com.ph/sign-up'
    },
    {
      title: 'Login',
      path: 'https://app.starjobs.com.ph/login'
    },
    {
      title: 'Home',
      path: 'homeSection'
    }
  ];
  
  export default menuConfig;